export const LEGAL_TEMPLATE_VERSION = 'branding-ip-v3-2026-visible-deliverables';

export const CONTRACT_STALE_CLIENT_MESSAGE =
  'Estamos actualizando el documento legal antes de habilitar la firma. Te avisaremos cuando este listo.';

export const CONTRACT_STALE_ADMIN_MESSAGE =
  'Este contrato usa una version legal anterior. Regenera el contrato antes de enviarlo o permitir firma.';

const CURRENT_LEGAL_MARKERS = [
  'contrato prestacion de servicios de branding y propiedad intelectual',
  'contrato prestacion de servicios de diseno y desarrollo web y propiedad intelectual',
  'primera. - partes',
  'naturaleza civil y ausencia de relacion laboral',
  'coescci',
  'cronograma de trabajo',
  'reunion de post-seguimiento',
  'obligaciones de las partes',
  'derechos de propiedad intelectual y registro',
  'centro de mediacion gea',
  'ley organica de proteccion de datos personales',
  'unicidad del acuerdo de voluntades',
];

const REQUIRED_CURRENT_LEGAL_MARKERS = [
  'entregables visibles para el cliente',
];

const OLD_LEGAL_MARKERS = [
  'firma electronica',
  'firma del estudio',
  'firma del cliente',
  'confidencialidad:',
  'propiedad intelectual:',
];

export function normalizeContractIntegrityText(value = '') {
  return String(value || '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/\s+/g, ' ')
    .trim()
    .toLowerCase();
}

function markerCount(normalized, markers) {
  return markers.reduce((count, marker) => (
    normalized.includes(marker) ? count + 1 : count
  ), 0);
}

export function getContractContentIntegrity(content = '') {
  const normalized = normalizeContractIntegrityText(content);
  const currentMarkerCount = markerCount(normalized, CURRENT_LEGAL_MARKERS);
  const requiredMarkerCount = markerCount(normalized, REQUIRED_CURRENT_LEGAL_MARKERS);
  const oldMarkerCount = markerCount(normalized, OLD_LEGAL_MARKERS);
  const hasContent = normalized.length > 0;
  const isCurrent = currentMarkerCount >= 5 && requiredMarkerCount === REQUIRED_CURRENT_LEGAL_MARKERS.length;
  const isOldShort = hasContent && !isCurrent && (
    oldMarkerCount >= 2 ||
    (oldMarkerCount >= 1 && normalized.includes('firma electronica'))
  );
  const isIncomplete = hasContent && !isCurrent;

  return {
    hasContent,
    isCurrent,
    isOldShort,
    isIncomplete,
    shouldBlockSignature: !isCurrent,
    currentMarkerCount,
    requiredMarkerCount,
    oldMarkerCount,
    legalTemplateVersion: LEGAL_TEMPLATE_VERSION,
  };
}

export function isCurrentLegalContractContent(content = '') {
  return getContractContentIntegrity(content).isCurrent;
}

export function isStaleContractLegalContent(content = '') {
  const integrity = getContractContentIntegrity(content);
  return integrity.hasContent && integrity.shouldBlockSignature;
}
